(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-anchor-nav"] && !Shopify.designMode) return;
  try {
    
  class AboutAnchorNav extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.links = Array.from(this.querySelectorAll('.about-anchor-nav__link'));
      if (!this.links.length) return;

      this.sections = this.links
        .map((link) => document.getElementById(link.dataset.target))
        .filter(Boolean);

      this.links.forEach((link) => {
        link.addEventListener('click', this.onLinkClick.bind(this));
      });

      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
        rootMargin: '-45% 0px -50% 0px',
        threshold: 0,
      });
      this.sections.forEach((target) => this.observer.observe(target));
    }

    getOffset() {
      const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      const navHeight = this.offsetHeight || 0;
      return (parseFloat(headerHeight) || 0) + navHeight;
    }

    onLinkClick(event) {
      const targetId = event.currentTarget.dataset.target;
      const target = document.getElementById(targetId);
      if (!target) return;
      event.preventDefault();

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const top = target.getBoundingClientRect().top + window.scrollY - this.getOffset();
      window.scrollTo({ top, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    }

    onIntersect(entries) {
      entries.forEach((entry) => {
        const link = this.links.find((item) => item.dataset.target === entry.target.id);
        if (!link) return;
        link.classList.toggle('is-active', entry.isIntersecting);
      });
    }
  }

  if (!customElements.get('about-anchor-nav')) {
    customElements.define('about-anchor-nav', AboutAnchorNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bespoke-journey"] && !Shopify.designMode) return;
  try {
    
  class BespokeVideo extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('.bespoke-journey__toggle');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.video) return;

      if (this.reducedMotion.matches) {
        this.video.pause();
        this.setPausedState(true);
      }

      if (this.toggle) {
        this.toggle.addEventListener('click', () => {
          if (this.video.paused) {
            this.video.play();
            this.setPausedState(false);
          } else {
            this.video.pause();
            this.setPausedState(true);
          }
        });
      }
    }

    setPausedState(isPaused) {
      this.classList.toggle('bespoke-journey__video-wrapper--paused', isPaused);
      if (this.toggle) this.toggle.setAttribute('aria-pressed', String(!isPaused));
    }
  }

  customElements.define('bespoke-video', BespokeVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bespoke-occasions"] && !Shopify.designMode) return;
  try {
    
  class BespokeLightboxGroup extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.image = this.dialog.querySelector('img');
      this.closeButton = this.dialog.querySelector('button');

      this.querySelectorAll('[data-full-src]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const src = trigger.dataset.fullSrc;
          if (!src) return;
          this.image.src = src;
          this.image.alt = trigger.dataset.fullAlt || '';
          this.dialog.showModal();
        });
      });

      this.closeButton.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }
  }

  if (!customElements.get('bespoke-lightbox-group')) {
    customElements.define('bespoke-lightbox-group', BespokeLightboxGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bespoke-process"] && !Shopify.designMode) return;
  try {
    
  class BespokeJourney extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.step));
      });
    }

    select(step) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.step === step;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      this.panels.forEach((panel) => {
        const active = panel.dataset.step === step;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  customElements.define('bespoke-journey', BespokeJourney);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bespoke-sketch-gallery"] && !Shopify.designMode) return;
  try {
    
  class SketchGalleryLightbox extends HTMLElement {
    constructor() {
      super();
      const dialog = this.querySelector('.bespoke-gallery-lightbox__dialog');
      if (!dialog) return;
      const itemsScript = this.querySelector('[data-lightbox-items]');
      const items = itemsScript ? JSON.parse(itemsScript.textContent) : [];
      const image = dialog.querySelector('.bespoke-gallery-lightbox__image');
      const titleEl = dialog.querySelector('.bespoke-gallery-lightbox__title');
      const descEl = dialog.querySelector('.bespoke-gallery-lightbox__desc');
      let currentIndex = 0;

      const show = (index) => {
        if (!items.length) return;
        currentIndex = (index + items.length) % items.length;
        const item = items[currentIndex];
        image.src = item.src || '';
        image.alt = item.alt || '';
        if (titleEl) titleEl.textContent = item.title || '';
        if (descEl) descEl.textContent = item.desc || '';
      };

      this.querySelectorAll('[data-lightbox-index]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          show(parseInt(trigger.dataset.lightboxIndex, 10));
          dialog.showModal();
        });
      });

      dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => dialog.close());
      dialog.querySelector('[data-lightbox-prev]').addEventListener('click', () => show(currentIndex - 1));
      dialog.querySelector('[data-lightbox-next]').addEventListener('click', () => show(currentIndex + 1));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }
  }

  if (!customElements.get('sketch-gallery-lightbox')) {
    customElements.define('sketch-gallery-lightbox', SketchGalleryLightbox);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bespoke-sketch-to-silk"] && !Shopify.designMode) return;
  try {
    
  class BespokeLightboxGroup extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.image = this.dialog.querySelector('img');
      this.closeButton = this.dialog.querySelector('button');

      this.querySelectorAll('[data-full-src]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const src = trigger.dataset.fullSrc;
          if (!src) return;
          this.image.src = src;
          this.image.alt = trigger.dataset.fullAlt || '';
          this.dialog.showModal();
        });
      });

      this.closeButton.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }
  }

  if (!customElements.get('bespoke-lightbox-group')) {
    customElements.define('bespoke-lightbox-group', BespokeLightboxGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class CollectionTabsComponent extends HTMLElement {
    constructor() {
      super();
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
        tab.addEventListener('keydown', this.onKeyDown.bind(this));
      });
    }

    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.setAttribute('aria-selected', isSelected);
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
      });
    }

    onKeyDown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let newIndex = null;

      switch (event.key) {
        case 'ArrowRight':
          newIndex = (currentIndex + 1) % this.tabs.length;
          break;
        case 'ArrowLeft':
          newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          break;
        case 'Home':
          newIndex = 0;
          break;
        case 'End':
          newIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      const newTab = this.tabs[newIndex];
      newTab.focus();
      this.selectTab(newTab);
    }
  }

  customElements.define('collection-tabs-component', CollectionTabsComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["designer-bio"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.about-founder__toggle');
    if (!toggle) return;
    const body = toggle.closest('.about-founder__content').querySelector('.about-founder__body');
    const collapsed = body.getAttribute('data-collapsed') === 'true';
    body.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', String(collapsed));
    toggle.textContent = collapsed
      ? toggle.dataset.lessLabel || 'Read Less'
      : toggle.dataset.moreLabel || 'Read More';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-first-order"] && !Shopify.designMode) return;
  try {
    
  class FirstOrderPopup extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'll_popup_state';
      this.dismissDays = parseInt(this.dataset.dismissDays, 10) || 7;
      this.closeButton = this.querySelector('.first-order-popup__close');
      this.dismissButton = this.querySelector('.first-order-popup__dismiss');
      this.form = this.querySelector('form');
      this.triggered = false;

      this.closeButton.addEventListener('click', () => this.close({ remember: true }));
      this.dismissButton.addEventListener('click', () => this.close({ remember: true }));
      this.addEventListener('keydown', this.onKeyDown.bind(this));

      if (this.form) {
        this.form.addEventListener('submit', () => {
          this.setAttribute('data-state', 'loading');
        });
      }

      const state = this.getState();

      if (this.dataset.posted === 'true') {
        // Page reloaded after a native form submission — show the result.
        if (this.dataset.postedSuccess === 'true') {
          this.setAttribute('data-state', 'success');
          this.saveState({ subscribed: true });
          this.open({ skipEligibility: true });
        } else {
          this.setAttribute('data-state', '');
          this.open({ skipEligibility: true });
        }
        return;
      }

      if (state.subscribed) return;
      if (state.dismissedAt && Date.now() - state.dismissedAt < this.dismissDays * 24 * 60 * 60 * 1000) return;

      this.armTriggers();
    }

    getState() {
      try {
        return JSON.parse(localStorage.getItem(this.storageKey)) || {};
      } catch (e) {
        return {};
      }
    }

    saveState(patch) {
      const state = Object.assign(this.getState(), patch);
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(state));
      } catch (e) {
        /* localStorage unavailable — pop-up will just show again next visit */
      }
    }

    armTriggers() {
      const delay = parseInt(this.dataset.delay, 10) || 6000;
      const scrollPercent = parseInt(this.dataset.scrollTrigger, 10) || 30;

      this.timeoutId = setTimeout(() => this.maybeOpen(), delay);

      this.onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 0) return;
        const percent = (window.scrollY / scrollable) * 100;
        if (percent >= scrollPercent) this.maybeOpen();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    maybeOpen() {
      if (this.triggered) return;
      this.triggered = true;
      clearTimeout(this.timeoutId);
      window.removeEventListener('scroll', this.onScroll);

      if (document.body.classList.contains('ll-chat-open')) return;
      this.open();
    }

    open(options) {
      options = options || {};
      if (!options.skipEligibility && document.body.classList.contains('ll-popup-open')) return;

      this.triggerElement = document.activeElement;
      this.setAttribute('open', '');
      document.body.classList.add('ll-popup-open');
      document.body.classList.add('overflow-hidden-tablet');
      window.dispatchEvent(new CustomEvent('lorraine-lee:popup-opened'));

      requestAnimationFrame(() => {
        const firstField = this.querySelector('input[type="email"]');
        if (firstField) firstField.focus();
      });

      this.trapFocusHandler = this.trapFocus.bind(this);
      document.addEventListener('keydown', this.trapFocusHandler);
    }

    close(options) {
      options = options || {};
      this.removeAttribute('open');
      document.body.classList.remove('ll-popup-open');
      document.body.classList.remove('overflow-hidden-tablet');
      document.removeEventListener('keydown', this.trapFocusHandler);

      if (options.remember) this.saveState({ dismissedAt: Date.now() });

      window.dispatchEvent(new CustomEvent('lorraine-lee:popup-closed', { detail: { delayChatMs: 20000 } }));

      if (this.triggerElement && typeof this.triggerElement.focus === 'function') {
        this.triggerElement.focus();
      }
    }

    onKeyDown(event) {
      if (event.code === 'Escape' || event.key === 'Escape') {
        this.close({ remember: true });
      }
    }

    trapFocus(event) {
      if (!this.hasAttribute('open') || event.key !== 'Tab') return;
      const focusable = this.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('first-order-popup', FirstOrderPopup);

  // Suppress this pop-up if a chat widget signals it is already showing an
  // invitation, and vice-versa: chat integrations should listen for
  // `lorraine-lee:popup-opened` / `lorraine-lee:popup-closed` (the latter's
  // `event.detail.delayChatMs` is the minimum delay before a chat prompt
  // should appear) and for the presence of the `ll-popup-open` body class.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductCollectionTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
        tab.addEventListener('keydown', this.onKeyDown.bind(this));
      });
    }

    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.classList.toggle('is-active', isSelected);
        tab.setAttribute('aria-selected', String(isSelected));
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      });
      this.panels.forEach((panel) => {
        const isSelected = panel.id === selectedTab.dataset.panel;
        panel.hidden = !isSelected;
        if (isSelected) this.resetPanelSlider(panel);
      });
    }

    resetPanelSlider(panel) {
      const slider = panel.querySelector('slider-component');
      if (!slider || !slider.slider) return;
      // Panels start hidden, so their slider-component measured 0 width on
      // first init (clientWidth is 0 while [hidden]) and never recomputed -
      // resetPages() re-measures now that the panel is actually visible.
      slider.resetPages();
      slider.slider.scrollTo({ left: 0, behavior: 'instant' });
    }

    onKeyDown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let newIndex = null;

      switch (event.key) {
        case 'ArrowRight':
          newIndex = (currentIndex + 1) % this.tabs.length;
          break;
        case 'ArrowLeft':
          newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          break;
        case 'Home':
          newIndex = 0;
          break;
        case 'End':
          newIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      const newTab = this.tabs[newIndex];
      newTab.focus();
      this.selectTab(newTab);
    }
  }

  if (!customElements.get('product-collection-tabs')) {
    customElements.define('product-collection-tabs', ProductCollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewCarouselDots extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.sliderComponent = this.closest('slider-component');
      if (!this.sliderComponent) return;

      this.sliderComponent.addEventListener('slideChanged', this.onSlideChanged.bind(this));

      this.resizeObserver = new ResizeObserver(() => this.render());
      this.resizeObserver.observe(this.sliderComponent);

      requestAnimationFrame(() => this.render());
    }

    render() {
      const totalPages = this.sliderComponent.totalPages || 1;
      if (this.renderedPages === totalPages) {
        this.updateActive();
        return;
      }
      this.renderedPages = totalPages;

      this.innerHTML = '';
      for (let i = 1; i <= totalPages; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'reviews__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `${i}`);
        dot.dataset.page = String(i);
        dot.addEventListener('click', () => this.goToPage(i));
        this.appendChild(dot);
      }
      this.updateActive();
    }

    updateActive() {
      const currentPage = this.sliderComponent.currentPage || 1;
      Array.from(this.children).forEach((dot) => {
        const isActive = Number(dot.dataset.page) === currentPage;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    }

    goToPage(page) {
      const slider = this.sliderComponent.slider;
      const offset = this.sliderComponent.sliderItemOffset || 0;
      slider.scrollTo({ left: offset * (page - 1) });
    }

    onSlideChanged() {
      this.updateActive();
    }
  }

  if (!customElements.get('review-carousel-dots')) {
    customElements.define('review-carousel-dots', ReviewCarouselDots);
  }

  } catch(e) { console.error(e); }
})();
})();
